<template>
	<div name="hres85u-popup-approve" id="hres85u-popup-approve" class="modal fade" role="dialog">
		<div class="modal-dialog modal-lg">
	    <div class="modal-content">
	      <div class="modal-header header-popup">
          <button type="button" class="close" data-dismiss="modal" ref="popupApproveModalButton">&times;</button>
          <h4 class="modal-title">{{ labels['HRES85UC2']['0'] }}</h4>
        </div>

        <div class="modal-body detail detail-responsive">
        	<div class="detail detail-responsive">

						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES85UC2']['10'] }}</div>
						  <div class="detail-right">
						      <div class="detail-text width-70" id="coddesc_codempid" name="desc_codempid">{{ approve.desc_codempid }}</div>
						  </div>
						</div>

						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES85UC2']['30'] }}</div>
						  <div class="detail-right">
						      <div class="detail-text width-70" id="coddesc_codappr" name="desc_codappr">{{ approve.codappr }} - {{ approve.desc_codappr }}</div>
						  </div>
						</div>

						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES85UC2']['40'] }}</div>
						  <div class="detail-right">
					      <div class="input-group width-70">
                  <hrms-datepicker  v-model="currentDate"
                                    v-show="false"
                                    v-validate="'required|date_format:DD/MM/YYYY'"
                                    data-vv-value-path="inputDate"
                                    name="currentDate"
                                    :has-error="errors.has('currentDate')" />

                  <hrms-datepicker  v-model="approve.dteappr"
                                    v-validate="'required|date_format:DD/MM/YYYY|after:currentDate'"
                                    data-vv-value-path="inputDate"
                                    name="dteappr"
                                    :has-error="errors.has('dteappr')" />
                  <div class="text-error" v-show="errors.has('dteappr')">{{errors.first('dteappr')}}</div>
                </div>
						  </div>
						</div>

						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES85UC2']['50'] }}</div>
						  <div class="detail-right">
						      <div class="input-group width-70">
                      <hrms-num-input class="width-75" 
                                v-model="approve.amtappr"
                                :numLength='9'
                                :decimal='2'
                                v-validate="'required'" 
                                name="amtappr"
                                data-vv-name="amtappr"
                                :class="{ 'input-error' : errors.has('amtappr') }"  />
						          <div class="input-group-addon input-group-addon-cust">{{ labels['HRES85UC2']['60'] }}</div>
						      </div>
						      <div v-show="errors.has('amtappr')" class="text-error">{{ errors.first('amtappr') }}</div>
						  </div>
						</div>

						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES85UC2']['70'] }}</div>
						  <div class="detail-right ">
						  		<input type="radio" name="typepay" id="typepay1" v-model="approve.typepay" value="1"/>
						  		<span class="radio-text">{{ labels['HRES85UC2']['80'] }}</span>

						      <input type="radio" name="typepay" id="typepay2" v-model="approve.typepay" value="2"/>
						      <span class="radio-text">{{ labels['HRES85UC2']['90'] }}</span>

						  </div>
						</div>

						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES85UC2']['100'] }}</div>
						  <div class="detail-right">
                <div class="input-group width-70">
						      <hrms-datepicker 	v-model="approve.dtepay"
                                    :disabled="disabledDtepay"
                                    v-validate="validateTypepay1,'|date_format:DD/MM/YYYY'"
                                    data-vv-value-path="inputDate"
                                    data-vv-name="dtepay"
                                    :name="boxType" />
                  <div class="text-error" v-show="errors.has('dtepay')">{{errors.first('dtepay')}}</div>
                </div>
						  </div>
						</div>

            <!-- <div class="clearfix detail-row">
              <div class="detail-left label-left">{{ labels['HRES85UC2']['110'] }}</div>
              <div class="detail-right">
                <div class="input-group width-70">
                  <hrms-dropdown  v-model="approve.numperiod"
                                  v-validate="validateTypepay2"
                                  data-vv-name="numperiod"
                                  data-vv-value-path="inputValue"
                                  :options="arrNumperiod"
                                  :disabled="disabledNumperiod" />
                  <div class="text-error" v-show="errors.has('numperiod')">{{errors.first('numperiod')}}</div>
                </div>
                <div class="input-group width-70">
                  <hrms-dropdown-month  v-model="approve.dtemthpay"
                                        :now-lang="nowLang"
                                        :disabled="disabledDtemthpay"/>
                </div>
                <input type="text" class="form-control input-text width-70" id="dteyrepay" name="dteyrepay" v-model="approve.dteyrepay" :disabled="disabledDteyrepay" />
              </div>
            </div>

						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES85UC2']['120'] }}</div>
						  <div class="detail-right">
                <div class="input-group width-70">
  					  		<hrms-dropdown  v-model="approve.codpay"
                                  :options="arrCodpay[nowLang]"
                                  v-validate="validateTypepay2"
                                  data-vv-value-path="inputValue"
                                  data-vv-name="codpay"
                                  :has-error="errors.has('codpay')" />
                  <div class="text-error" v-show="errors.has('codpay')">{{errors.first('codpay')}}</div>
                </div>
						  </div>
						</div> -->

						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES85UC2']['130'] }}</div>
						  <div class="detail-right">
						      <div class="detail-text width-70" id="status" name="status">{{ approve.status }}</div>
						  </div>
						</div>

						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES85UC2']['170'] }}</div>
						  <div class="detail-right">
						    <textarea class="textarea-text width-70" 
                          v-model="approve.remark" 
                          id="remark" 
                          maxlength="500"
                          v-validate="'max:500'"
                          data-vv-name="remark"
                          :has-error="errors.has('remark')" ></textarea>
                <div class="text-error" v-show="errors.has('remark')">{{errors.first('remark')}}</div>
                <div class="remark-limit-character">{{ dispLimitLabel(500) }}</div> 
							</div>
						</div>

        	</div>
        </div>

        <div class="modal-footer align-center border-color-skin">
          <button type="button" class="btn bg-green" @click="validatePopupApprove()" ><i class="fa fa-check-circle"></i> {{ labelsButton['approve'] }}</button>
        </div>

	    </div>
    </div>
	</div>
</template>

<script>
import moment from 'moment'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hres85u-popup-approve',
  data () {
    return {
      regex: require('assets/js/regex'),
      approve: {
        codempid: '',
        desc_codempid: '',
        approvno: 0,
        chk_appr: '',
        numseq: 0,
        dtereq: '',
        codappr: '',
        desc_codappr: '',
        dteappr: '',
        amtappr: '',
        typepay: '2',
        dtepay: '',
        numperiod: '',
        dtemthpay: moment().month() + 1,
        dteyrepay: moment().year(),
        codpay: '',
        staappr: '',
        flgStaappr: '',
        status: '',
        remark: '',
        minYear: moment().year() - 20,
        maxYear: moment().year()
      },
      currentDate: moment().format('DD/MM/YYYY'),
      disabledDtepay: false,
      disabledNumperiod: false,
      disabledDtemthpay: false,
      disabledDteyrepay: false,
      validateTypepay1: '',
      validateTypepay2: 'required'
    }
  },
  created () {
    // if (typeof this.arrNumperiod[this.approve.numperiod] === 'undefined') {
    //   this.approve.numperiod = ''
    // }
    // if (typeof this.arrCodpay[this.nowLang][this.approve.codpay] === 'undefined') {
    //   this.approve.codpay = ''
    // }
  },
  watch: {
    enableTypepay () {
      if (this.enableTypepay === 'T') {
        this.approve.typepay = '1'
      } else if (this.enableTypepay === 'T') {
        this.approve.typepay = '2'
      }
    },
    detailSubmit () {
      this.approve = {
        codempid: this.indexSelected.codempid,
        desc_codempid: this.indexSelected.desc_codempid,
        approvno: this.indexSelected.approvno,
        chk_appr: this.indexSelected.chk_appr,
        numseq: this.indexSelected.numseq,
        dtereq: this.indexSelected.dtereq,
        codappr: this.codappr,
        desc_codappr: this.descCodappr,
        dteappr: moment().format('DD/MM/YYYY'),
        amtappr: this.detailSubmit.amtappr,
        typepay: this.detailSubmit.typepay,
        dtepay: this.detailSubmit.dtepay,
        numperiod: this.detailSubmit.numperiod,
        dtemthpay: this.detailSubmit.dtemthpay,
        dteyrepay: this.detailSubmit.dteyrepay,
        codpay: this.detailSubmit.codpay,
        staappr: this.indexSelected.staappr,
        flgStaappr: this.indexSelected.flgStaappr,
        status: this.indexSelected.status,
        remark: ''
      }
      this.$nextTick(function () {
        this.errors.clear()
      })
    },
    'approve.typepay' (newVal) {
      if (newVal === '1') {
        this.disabledDtepay = false
        this.disabledNumperiod = true
        this.disabledDtemthpay = true
        this.disabledDteyrepay = true
        this.validateTypepay1 = 'required'
        this.validateTypepay2 = ''
      } else if (newVal === '2') {
        this.disabledDtepay = true
        this.disabledNumperiod = false
        this.disabledDtemthpay = false
        this.disabledDteyrepay = false
        this.validateTypepay1 = ''
        this.validateTypepay2 = 'required'
      }
    }
  },
  props: [ 'labels', 'nowLang', 'postHres85uSendApprove', 'indexSelected', 'arrCodpay', 'arrNumperiod', 'enableTypepay', 'typepay', 'codappr', 'descCodappr', 'labelsButton', 'detailSubmit' ],
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    validatePopupApprove () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.postHres85uSendApprove(this.sendApprove())
        }
      })
    },
    sendApprove () {
      return {
        approveParams: this.approve,
        referenceButton: this.$refs.popupApproveModalButton
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// popupApprove.vue?2d542c06